module.exports = __webpack_public_path__ + "img/sambo.84217837.jpeg";